import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ImpersonationBroker, asApiError } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { queryKeys } from './queryKeys';

export type UpdateLeadAttributeVariables = {
	companyId: string;
	/** Form field id (the attribute's `{fieldId}`). */
	fieldId: string;
	/** Selected option id — the `Value` the BE's `SetAttributeRequest` expects. */
	value: string;
};

// Writes the attribute value to the HubSpot Company object directly — no deal required.
export function useUpdateLeadAttribute() {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation<void, Error, UpdateLeadAttributeVariables>({
		mutationFn: async ({ companyId, fieldId, value }) => {
			const result = await userSession.webServiceHelper.callWebServiceAsync<unknown>(
				ImpersonationBroker.composeApiUrl({ urlPath: `lead/${companyId}/Lead/Field/${fieldId}` }),
				'PUT',
				{ value }
			);
			if (!result.success) {
				throw asApiError(result);
			}
		},
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.focusedView.lead(variables.companyId) });
		},
	});
}
